import styled from '@emotion/styled'
import { Box } from '@mui/system'
import { AssetData } from 'constants/assets'
import CoreToken from 'core/CoreToken'
import { useState } from 'react'
import CollapseIcon from 'assets/icons-gray/collapse.svg'

const DropDownContainer = styled(Box)<{ isOpen: boolean }>`
  width: 140px;
  max-height: 270px;
  border-radius: 8px;
  background-color: ${({ isOpen }) => (isOpen ? 'white' : 'transparent')};
  cursor: pointer;
  z-index: 50;
  overflow-x: hidden;
  position: absolute;
  :hover {
    background-color: white;
  }
`
const DropDownHeader = styled(Box)<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 7px 12px;
  :hover {
    background-color: ${({ isOpen }) =>
      isOpen ? 'rgba(0, 0, 0, 0.08)' : 'transparent'};
  }
`
const DropDownListContainer = styled(Box)``
const DropDownList = styled.ul`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`
const ListItem = styled.li`
  list-style: none;
  padding: 7px 12px;
  :hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`

interface Props {
  selectedToken?: AssetData
  tokens: AssetData[]
  onSelect: Function
}

const DropdownToken = ({
  tokens,
  onSelect,
  selectedToken: _selectedToken,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  if (tokens.length === 0) return <></>

  const selectedToken = _selectedToken ? _selectedToken : tokens[0]
  const _tokens = tokens.filter(
    (token) => token.terraAddress !== selectedToken.terraAddress,
  )
  const toggling = () => setIsOpen(!isOpen)
  const onOptionClicked = (value: AssetData) => () => {
    onSelect(value)
    setIsOpen(false)
  }

  return (
    <DropDownContainer isOpen={isOpen}>
      <DropDownHeader isOpen={isOpen} onClick={toggling}>
        <CoreToken assetData={selectedToken} size={28} withName />
        <img
          src={CollapseIcon}
          alt="CollapseIcon"
          style={{
            transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
          width={24}
          height={24}
        />
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList>
            {_tokens.map((token: AssetData, i) => (
              <ListItem onClick={onOptionClicked(token)} key={i}>
                <CoreToken assetData={token} size={28} withName />
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  )
}

export default DropdownToken
